import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { INTRO_DURATION } from '../utils/constants';

export default function Intro() {
    const navigate = useNavigate()
    const [step, setStep] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (step === 2) navigate("/game")
            else setStep(step => step + 1)
        }, INTRO_DURATION)
        return () => {
            timeout && clearTimeout(timeout)
        }
    }, [step])


    return <section className='intro-container'>
        {step === 0 &&
            <article className='title-container'>
                <div className='banner'>
                    <div className="content">
                        WORLD DIABETES DAY
                    </div>
                </div>
                <footer>
                    <img src='/assets/astrazeneca.png' />
                </footer>
            </article>}
        {step === 1 && <article className='hint-container'>
            <div className='banner'>
                <div className="content">
                    TRY TO PICK HEALTHY ONES FOR A BETTER WELLBEING
                </div>
            </div></article>}
        {step === 2 && <article className='image-container'>
            <div className='banner'>
                <div className="content">
                    <img src="/assets/lets-start.png" />
                </div>
            </div></article>}
    </section>
}